import LocalizedStrings from "react-localization";
import LocalText from "src/local";

const localizationStrings = new LocalizedStrings({
  ja: {
    label: LocalText.screens.authSignupConfirm.label,
    inputCodePlaceholder:
      LocalText.screens.authSignupConfirm.inputCodePlaceholder,
    inputCodeValidationRequire:
      LocalText.screens.authSignupConfirm.inputCodeValidationRequire,
    btnReset: LocalText.screens.authSignupConfirm.btnReset,
  },
});

export { localizationStrings };
